export class FlowSheetRunDetail {
    flowSheetId: number;
    flowSheetRunId: number;
    flowSheetName: string;
    status: string;
    startTime: Date;
    endTime: Date;
    runCreatedBy: string;
  
    constructor() {
      this.flowSheetId = 0;
      this.flowSheetRunId = 0;
      this.flowSheetName = '';
      this.status = '';
      this.startTime = null;
      this.endTime = null;
      this.runCreatedBy = '';
    }
  }
  
  export class ModelRunDetail {
    modelUniqueId: string;
    modelName: string;
    status: string;
    startTime: Date;
    endTime: Date;
  
    constructor() {
      this.modelUniqueId = '';
      this.modelName = '';
      this.status = '';
      this.startTime = null;
      this.endTime = null;
    }
  }
  
  export class ModelRunParameterDetail {
    parameterName: string;
    parameterDisplayName: string;
    value: string;
  
    constructor() {
      this.parameterName = '';
      this.parameterDisplayName = '';
      this.value = '';
    }
  }